import {capitalize} from "lodash"


export const STATUS_CREATED = "created"
export const STATUS_WAITING_TO_BE_OPENED = "waiting_to_be_opened"
export const STATUS_OPENING = "opening"
export const STATUS_OPEN = "open"
export const STATUS_CLOSED = "closed"
export const STATUS_SENDING = "sending"
export const STATUS_SCHEDULED = "scheduled"

export const SURVEY_STATUSES = [
  STATUS_CREATED,
  STATUS_WAITING_TO_BE_OPENED,
  STATUS_OPENING,
  STATUS_OPEN,
  STATUS_CLOSED
]

export const SENDING_STATUSES = [
  STATUS_CREATED,
  STATUS_WAITING_TO_BE_OPENED,
  STATUS_OPENING,
  STATUS_SENDING
]


export const SURVEY_STATUS_OPTIONS = SURVEY_STATUSES.map((value) => ({
  label: capitalize(value.split("_").join(" ")),
  value
}))
